import { platformStorage } from '../../shared/stores/platformStorage';
import { WORLD_CUP_WELCOME_STORAGE } from '../worldcup.constants';
import { worldCupWelcomeStorageKey } from './worldcupWelcomeStorageKey.helper';

export { worldCupWelcomeStorageKey } from './worldcupWelcomeStorageKey.helper';

export async function readWorldCupWelcomeCompleted(
  userId: string | null | undefined,
): Promise<boolean> {
  const key = worldCupWelcomeStorageKey(userId);
  const raw = await Promise.resolve(platformStorage.getItem(key));
  return raw === WORLD_CUP_WELCOME_STORAGE.COMPLETED_VALUE;
}

export async function writeWorldCupWelcomeCompleted(userId: string | null | undefined): Promise<void> {
  const key = worldCupWelcomeStorageKey(userId);
  await Promise.resolve(platformStorage.setItem(key, WORLD_CUP_WELCOME_STORAGE.COMPLETED_VALUE));
}
